// extracted by mini-css-extract-plugin
export default {"boxCrypto":"Lander_boxCrypto__dBf7p","boxInput":"Lander_boxInput__Sz70Z","input":"Lander_input__rB4bc","discrption":"Lander_discrption__+Oe8p"};